import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select/select.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SelectOptionDirective } from './select-option.directive';
import { IconModule } from '../icon/icon.module';
import { CheckboxModule } from '../checkbox/checkbox.module';
import { InputErrorModule } from '../input-error/input-error.module';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [
    SelectComponent,
    SelectOptionDirective
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconModule,
    CheckboxModule,
    InputErrorModule,
    ScrollingModule
  ],
  exports: [
    SelectComponent,
    SelectOptionDirective
  ]
})
export class SelectModule { }
